import { BoardModel, convertBoardToModel } from "~utils";

import { useBoardState } from "../board-state";

export function useViewBoard(): useViewBoardReturn {
  const { board } = useBoardState();

  return {
    board: board ? convertBoardToModel(board) : undefined,
  };
}

export type useViewBoardReturn = { board?: BoardModel };
